import { Button, Heading, HStack, StackProps, Text, VStack } from "@chakra-ui/react";
import { useTranslation } from "react-i18next";
import { ExportTarget } from "../pages/converter/PresetConverter";

interface Props extends StackProps {
    onTargetSelect: (target: ExportTarget) => void;
}

export const TargetSelectStage = ({ onTargetSelect, ...props }: Props) => {
    const { t } = useTranslation();
    return (
        <VStack gap='2rem' justifyContent='center' textAlign='center' {...props}>
            <Text as='p' color='#fff' fontSize='lg'>
                {t('targetSelectDescription')}
            </Text>
            <HStack gap='3rem' flexWrap={'wrap'} flexDirection={{ base: 'column', md: 'row' }}>
                {['MKv1.2', 'MK2'].map((target) => (
                    <Button
                        height='10rem'
                        width='15rem'
                        onClick={() => onTargetSelect(target as ExportTarget)}
                        variant='outline'
                        key={target}
                        border='3px solid #fff'
                        fontWeight='bold'
                        fontSize='2em'
                        color='white'
                    >
                        {target === 'MKv1.2' ? 'MK I (v1.2+)' : 'MK II'}
                    </Button>
                ))}
            </HStack>
        </VStack>
    );
};